import { render, staticRenderFns } from "./Dynamicpages.vue?vue&type=template&id=1ec05e8c&scoped=true&"
import script from "./Dynamicpages.vue?vue&type=script&lang=js&"
export * from "./Dynamicpages.vue?vue&type=script&lang=js&"
import style0 from "./Dynamicpages.vue?vue&type=style&index=0&id=1ec05e8c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec05e8c",
  null
  
)

export default component.exports